module.exports = __webpack_public_path__ + "static/media/clumsy.ddea1b09.svg";